import { render } from "./AdminChatView.vue?vue&type=template&id=20278b8b&scoped=true&ts=true"
import script from "./AdminChatView.vue?vue&type=script&lang=ts"
export * from "./AdminChatView.vue?vue&type=script&lang=ts"

import "./AdminChatView.vue?vue&type=style&index=0&id=20278b8b&scoped=true&lang=scss"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20278b8b"]])

export default __exports__